<template>
		<div>
			<div class="col-xs-12">
				<figure class="obj-cont">
					<img v-bind:src="pagina.better_featured_image.source_url" alt="" class="obj-img">
				</figure>
			</div>
			<article class="col-xs-12" v-html="pagina.content.rendered"></article>
		</div>

</template>

<script>
export default {
	props:[
		'pagina',
	],
	mounted: function() {
		// this.getPage();
	},
	data() {
		return {
			page: {},
			page_childrens: {},
			loaded: 'false',
			loaded_childrens: 'false',
			pageTitle: ''
		};
	},
	methods: {

	},
	watch: {
	}
};
</script>



// WEBPACK FOOTER //
// page_opiniones.vue?26eefa79